import { init } from '@sentry/react';
init({
  dsn: 'https://2fd0165a73fa68f23a361242fd8d97c8@o292676.ingest.us.sentry.io/4509864589328384',
  enabled: import.meta.env.PROD,
});
